import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isLoading: false,
    data: [],
    error: null,
};

const viewSegementSlice = createSlice({
    name: 'ViewSegments',
    initialState,
    reducers: {
        getSegmentList: (state, action) => {
            state.isLoading = true
        },
        getSegmentListSuccess: (state, action) => {
            state.isLoading = false
            state.data = action.payload
        },
        getSegmentListError: (state, action) => {
            state.isLoading = false
            state.error = action.payload
        },
    },
});

export const {
    getSegmentList,
    getSegmentListSuccess,
    getSegmentListError,
} = viewSegementSlice.actions;

export default viewSegementSlice.reducer;
